/**
 * Central reducer action names for cohort graph state transitions.
 * Keep all reducer callers aligned to these constants.
 */
export const GRAPH_ACTIONS = Object.freeze({
  ADD_NODE: 'ADD_NODE',
  UPDATE_NODE: 'UPDATE_NODE',
  DELETE_NODE: 'DELETE_NODE',
  SET_GRAPH: 'SET_GRAPH',
});
